import React from "react";
import { Skeleton } from "@material-ui/lab";

export default function ShareDetailCardSkeleton() {
  return (
    <div
      className="d-flex align-items-center p-3 bg-white rounded"
      style={{ gap: 16 }}
    >
      {/* ===== Image ===== */}
      <Skeleton
        variant="rect"
        width={90}
        height={90}
        style={{ borderRadius: 8 }}
      />

      {/* ===== Right Content ===== */}
      <div className="flex-grow-1">

        {/* ID row */}
        <div className="d-flex align-items-center mb-2" style={{ gap: 10 }}>
          <Skeleton variant="circle" width={26} height={26} />
          <Skeleton variant="text" width={160} height={24} />
          <Skeleton variant="text" width={140} height={24} />
        </div>

        {/* Description */}
        <Skeleton variant="text" width="75%" height={28} />

        {/* Price per ct */}
        <Skeleton variant="text" width={120} height={20} />

        {/* Main price */}
        <Skeleton variant="text" width={140} height={34} />
      </div>
    </div>
  );
}